import { render, staticRenderFns } from "./UserSettingsConnectWithXero.vue?vue&type=template&id=8985d6a8&scoped=true&"
import script from "./UserSettingsConnectWithXero.vue?vue&type=script&lang=js&"
export * from "./UserSettingsConnectWithXero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8985d6a8",
  null
  
)

export default component.exports